import script from "./PdfHighlight.vue?vue&type=script&setup=true&lang=js"
export * from "./PdfHighlight.vue?vue&type=script&setup=true&lang=js"

import "./PdfHighlight.vue?vue&type=style&index=0&id=5acdd530&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5acdd530"]])

export default __exports__